import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PostServices from '../../services/PostServices';
import ImageStorage from '../../utils/ImageStorage';

const PostDetailsPage = () => {
  //
  const { postId } = useParams();
  const [postDetail, setPostDetail] = useState<any>({});

  useEffect(() => {
    if (postId) {
      getPostDetail(postId);
    }
  }, []);

  const getPostDetail = async (postId: string) => {
    const _postDetail = await PostServices.getPostDetail(postId);
    if (_postDetail) {
      setPostDetail(_postDetail);
    }
  };

  function decodeHTMLEntities(text: string) {
    const textArea = document.createElement('textarea');
    textArea.innerHTML = text;
    return textArea.value;
  }

  return (
    <>
      <div className='post-page page-background'>
        <div className='sub-banner'>
          <div className='container mx-auto flex relative h-full overflow-y-visible overflow-x-visible'>
            <div className='banner-char'></div>
            <div className='banner-text'>
              <a className='home-button' href='/'>
                <img
                  src={ImageStorage.HomeButton}
                  alt='TOP 1 game quan đấu trên Zalo'
                />
              </a>
            </div>
          </div>
        </div>
        <div className='container mx-auto page-title-container'>
          <h1 className='page-title'>{postDetail.title}</h1>
        </div>
        <div className='container mx-auto'>
          <div className='post-content'>
            <div
              dangerouslySetInnerHTML={{
                __html: decodeHTMLEntities(postDetail.content),
              }}
            />
            {/* <div className='post-title mt-4'>
              Khuyến Mãi Ngày
              <br />
              Quốc Tế Phụ Nữ 08/03
            </div>
            <div className='post-thumbnail'>
              <img
                src='/assets/images/post-thumbnail.f43ac062.png'
                alt='Thumbnail'
              />
            </div>
            <p className='post-text'>
              Thời gian: 1 ngày (0:00 ngày 08/03 đến 23:59 ngày 08/03)
              <br />
              <br />
              Phạm vi: S1 đến S12 <br />
              <br />
              Lạc Dương, Trường An, Thiên Thủy, Khai Phong Hổ Lao Quan, Thượng
              Dung, Nội Hân, Hoa Âm Nghi Dương, Uyển Lâm, Hãn Đông, Hoằng Nông
              Nội dung sự kiện: <br />
              <br />
              Trong thời gian diễn ra sự kiện, khi Chúa Công nạp gói 800 Nguyên
              Bảo, sẽ nhận được 1 rương Linh Dực Vàng và 3 rương Hồn cánh tím.
              Sự kiện chỉ áp dụng 1 lần duy nhất cho mỗi nhân vật. Phần thưởng
              sẽ được gửi qua Thư trong vòng 24 giờ sau khi nạp thành công. Xin
              lưu ý: Sự kiện chỉ ghi nhận khi nạp gói 800 Nguyên Bảo, những gói
              nạp khác sẽ không được tính. <br />
              <br />
              Truy cập trang nạp thẻ để nhận về ưu đãi tốt nhất. <br />
              <br />
              Thông tin phần thưởng:​
            </p>
            <div className='post-img'>
              <img
                src='/assets/images/post-table.d787b32a.png'
                alt='Thông tin phần thưởng'
              />
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default PostDetailsPage;
